import './App.css';
import React, { useState } from 'react';
import Main from './Components/Main';
import LogIn from './Components/LogIn';
import { ThemeProvider } from "./Components/ui";


const App = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [token, setToken] = useState("");

    const logInHandler = (newToken) => {
        setIsLoggedIn(true);
        setToken(newToken);
    }

    const logOut = () => {
        localStorage.removeItem('authToken');
        setIsLoggedIn(false);
        setToken("");
    }

    return (
        <div className="App" >
            <ThemeProvider>
                <div id="bp3d-js-app">
                    {!isLoggedIn ? <LogIn logInHandler={logInHandler} /> : <Main logOut={logOut} />}
                </div>
            </ThemeProvider>
        </div>

    );
}

export default App;
